const STORE_ID = "141596753";
let promise;

export function loadEcwid() {
  if (window.Ecwid?.Cart?.get) return Promise.resolve(window.Ecwid);
  if (promise) return promise;
  promise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-ecwid="store"]');
    if (existing) {
      const poll = setInterval(() => {
        if (window.Ecwid?.Cart?.get) {
          clearInterval(poll);
          resolve(window.Ecwid);
        }
      }, 150);
      setTimeout(() => {
        clearInterval(poll);
        if (!window.Ecwid?.Cart?.get) reject(new Error("Ecwid timeout"));
      }, 20000);
      return;
    }
    const script = document.createElement("script");
    script.src = `https://app.ecwid.com/script.js?${STORE_ID}&data_platform=code`;
    script.async = true;
    script.charset = "utf-8";
    script.setAttribute("data-cfasync", "false");
    script.setAttribute("data-ecwid", "store");
    script.onerror = () => {
      promise = null;
      reject(new Error("Ecwid failed to load"));
    };
    script.onload = () => {
      try {
        window.Ecwid?.init?.();
      } catch {}
      const poll = setInterval(() => {
        if (window.Ecwid?.Cart?.get) {
          clearInterval(poll);
          resolve(window.Ecwid);
        }
      }, 150);
      setTimeout(() => {
        clearInterval(poll);
        if (!window.Ecwid?.Cart?.get) {
          promise = null;
          reject(new Error("Ecwid timeout"));
        }
      }, 20000);
    };
    document.body.appendChild(script);
  });
  return promise;
}

export const addEcwidItem = ({ id, quantity, options }) =>
  loadEcwid().then(
    (Ecwid) =>
      new Promise((resolve) => {
        const t = setTimeout(() => resolve({ success: false, error: "timeout" }), 12000);
        Ecwid.Cart.addProduct({
          id: Number(id),
          quantity: Number(quantity),
          ...(options ? { options } : {}),
          callback: (success, product, cart, error) => {
            clearTimeout(t);
            resolve({ success, error, cart });
          },
        });
      })
  );

export const clearEcwidCart = () =>
  loadEcwid().then(
    (Ecwid) =>
      new Promise((resolve) => {
        if (!Ecwid.Cart?.clear) return resolve(false);
        const t = setTimeout(() => resolve(false), 8000);
        try {
          Ecwid.Cart.clear({
            callback: () => {
              clearTimeout(t);
              resolve(true);
            },
          });
        } catch {
          try {
            Ecwid.Cart.clear(() => {
              clearTimeout(t);
              resolve(true);
            });
          } catch {
            clearTimeout(t);
            resolve(false);
          }
        }
      })
  );

export const getEcwidCart = () =>
  loadEcwid().then(
    (Ecwid) =>
      new Promise((resolve) => {
        const t = setTimeout(() => resolve(null), 10000);
        Ecwid.Cart.get({
          callback: (cart) => {
            clearTimeout(t);
            resolve(cart);
          },
        });
      })
  );

export async function syncEcwidCart(lines) {
  await loadEcwid();
  await clearEcwidCart();
  for (const line of lines) {
    await addEcwidItem(line);
  }
}
